module.exports = __webpack_public_path__ + "static/media/Hearts.29bda664.png";